import * as React from 'react';
import { Modal, Button } from 'kui';
import './_PermissionsFAQModal.scss';
import {
    IPermissionFAQModalProps
} from './types';
import { ESourceValue } from '../../constants';

export function PermissionsFAQModal ({
   onClick,
   onClose
}: IPermissionFAQModalProps) {

    return (
        <Modal
            title={'Kanbanchi needs specific permissions. <br/>Don’t worry, it is absolutely safe.'}
            variant={'actions'}
            className={'permissions-faq'}
            onClose={onClose}
        >
            <img
                src={'/demo/img/permissions-list.png'}
                alt="#"
                className={'permissions-faq__image'}
            />
            <p className={'permissions-faq__text'}>To function properly, Kanbanchi requires access to your Google Drive and the ability to manage files within it. Please ensure you check all boxes during the sign-up process.</p>
            <p className={'permissions-faq__text'}>For more information, <a className={'permissions-faq__link'} href={'https://www.kanbanchi.com/faqwd/permissions'} target={'_blank'} onClick={() => onClick(ESourceValue.FAQ)}>visit our FAQ </a> <br/>
                or <a className={'permissions-faq__link'} href={'https://www.kanbanchi.com/contacts'} target={'_blank'} onClick={() => onClick(ESourceValue.CONTACT)}>contact our support team</a> for assistance.</p>
            <Button
                className={'permissions-faq__button'}
                onClick={onClose}
            >OK</Button>
        </Modal>
    );
}
